'use strict'

const integrations = {
    'facebook-pixel': require('@segment/analytics.js-integration-facebook-pixel'),
    'tiktok': require('../../custom/tiktok'),
}

module.exports = integrations;
